<template>
    <v-row no-gutters class="mt-4">
        <v-col cols="12">
            <v-text-field
                outlined
                :placeholder="$vuetify.lang.t('$vuetify.custom.login.loginName')"
                :rules="[rules.required]"
                full-width
                prepend-inner-icon="mdi-account"
                v-model="formData.account"
                @keyup.enter.native="login"
            ></v-text-field>
        </v-col>
        <v-col cols="12">
            <v-text-field
                v-model="formData.password"
                :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="[rules.required]"
                :type="show ? 'text' : 'password'"
                outlined
                :placeholder="$vuetify.lang.t('$vuetify.custom.login.password')"
                full-width
                prepend-inner-icon="mdi-lock"
                @click:append="show = !show"
                @keyup.enter.native="login"
            ></v-text-field>
        </v-col>
        <v-col cols="12">
            <v-btn block depressed color="#00C1DE" x-large style="color:#fff;" @keyup.enter.native="login"
                   @click="login">{{$vuetify.lang.t('$vuetify.custom.login.login')}}
            </v-btn>
        </v-col>
        <v-col cols="12" class="my-6">
            <a class="ml-2 float-right">{{$vuetify.lang.t('$vuetify.custom.login.register')}}</a>
            <a class="ml-2 float-right">{{$vuetify.lang.t('$vuetify.custom.login.forgetUsername')}}</a>
            <a class="ml-2 float-right">{{$vuetify.lang.t('$vuetify.custom.login.forgetPassword')}}</a>
        </v-col>
    </v-row>
</template>
<style>
    a {
        text-decoration: none;
        font-family: 'Roboto,sans-serif';
        font-weight: 400;
        font-style: normal;
        font-size: 12px;
        color: #999 !important;
    }
</style>
<script>
    import md5 from 'js-md5'

    export default {
        name: 'password-login',
        data() {
            return {
                show: false,
                formData: {
                    account: '',
                    password: ''
                },
                rules: {
                    required: value => !!value || this.$vuetify.lang.t('$vuetify.custom.pleaseEnery')
                }
            }
        },
        methods: {
            login() {
                this.loading = true;
                //this.formData.password = md5(this.formData.account+this.formData.password);
                let loginData = {
                    username: this.formData.account,
                    password: md5(this.formData.account + this.formData.password)
                }
                this.$api.sys.login(loginData).then(data => {
                    this.loading = false;
                    if (data.flag) {
                        //这里将token 放入vuex中
                        this.$store.commit('set_token', data.headers.authorization);
                        this.$store.commit('setPermissionList', data.data.permissions);
                        let items = this.$utils.menu.sortMenu(data.data.menus);
                        this.$store.commit('setMenuItems', items);
                        //这里跳转路由 登录成功的
                        this.$router.push("home");
                        this.$api.sys.getUserInfo().then(userInfo => {
                            this.$store.commit('setUserInfo', userInfo.data);
                        });
                    } else {
                        if (data.code < 3000 || data.code > 3099) {
                            if (data.msg) {
                                this.$dialog.alert(data.msg);
                            }
                        }
                    }
                });
            }
        }
    }
</script>
